import { defineStore } from "pinia";

export const useCategoryPageStore = defineStore("categoryPage", {
  state: () => ({
    currentPage: 1,
    categoryPages: {} as Record<string | number, number>, 
    landingPages: {} as Record<string, number>,
  }),
  getters: {
    getCurrentPage: (state) => state.currentPage,
    getCategoryPage: (state) => (uid: string | number) => state.categoryPages[String(uid)] || 1,
    getLandingPage: (state) => (uid: string | number) => state.landingPages[String(uid)] || 1,
  },
  actions: {
    setCurrentPage(page: number) {
      this.currentPage = page;
    },
    resetCurrentPage() {
      this.currentPage = 1;
    },

    setCategoryPage(uid: string | number, page: number) {
      const key = String(uid);
      this.categoryPages = {
        ...this.categoryPages,
        [key]: page
      };
    },
    resetCategoryPage(uid: string | number) {
      const key = String(uid);
      this.categoryPages = {
        ...this.categoryPages,
        [key]: 1
      };
    },

    setLandingPage(uid: string | number, page: number) {
      const key = String(uid);
      this.landingPages = {
        ...this.landingPages,
        [key]: page
      };
    },
    resetLandingPage(uid: string | number) {
      const key = String(uid);
      this.landingPages = {
        ...this.landingPages,
        [key]: 1
      };
    },
  },
});
